import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable, Subject} from 'rxjs';
import {map} from 'rxjs/operators';

import {LogEvent, UpdateLogEvent} from './log-event.model';

import {REQUEST_OPTIONS} from '../../app.constants';
import {ApiService} from '../api';

@Injectable({
  providedIn: 'root'
})
export class LogEventService {

  public logEventStatusModified: Subject<boolean> = new Subject<boolean>();
  public logEventsRefreshed$: Subject<void> = new Subject();

  constructor(private api: ApiService) {
  }

  public findLogEvents(itemId: number,
                       itemType?: string, level?: string, eventType?: string, category?: string, createDate?: string, message?: string,
                       hiddenCategory?: string,
                       perPage: number = 10, page: number = 0, orderBy?: string): Observable<{
    total: string | number,
    data: LogEvent[]
  }> {
    const searchItems = [];
    if (itemType) {
      searchItems.push(`itemType==${itemType}`);
    }
    if (level) {
      searchItems.push(`level==${level}`);
    }
    if (eventType) {
      searchItems.push(`eventType==${eventType}`);
    }
    if (category) {
      searchItems.push(`category=='*${category}*'`);
    }
    if (hiddenCategory) {
      searchItems.push(`category!=${hiddenCategory}`);
    }
    if (createDate) {
      searchItems.push(`createDate=ge=${createDate}T00:00:00.000;createDate=le=${createDate}T23:59:59.999`);
    }
    if (message) {
      searchItems.push(`message=='*${message}*'`);
    }
    let search = '';
    if (searchItems?.length > 0) {
      search = `search=${searchItems.join(';')}&`;
    }
    return this.api.ga
      .post(`/log-events/list-by-post?${search}page=${page}&per-page=${perPage}&order-by=${encodeURIComponent(orderBy)}`,
        [itemId],
        REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        map((response: HttpResponse<LogEvent[]>) => ({
          data: response.status === 204 ? [] : response.body,
          total: response.headers.get('x-total-count') || 0
        }))
      );
  }

  public patchLogEvent(logEventId: number, updateLogEvent: UpdateLogEvent): Observable<LogEvent> {
    return this.api.ga.patch(`/log-events/${logEventId}`, updateLogEvent);
  }
}
